import { CHANNEL_COUNT_FOR_WALLPAPER } from '../../constants';

import { getChannelWallpapersForPaywall } from './getChannelWallpapersForPaywall';
import { ChannelWallpaperItem } from './getChannelsWallpapers';

interface Params {
    allowedChannelWallpapers: ChannelWallpaperItem[] | undefined;
    currentChannelWallpaper: ChannelWallpaperItem;
}

export const getPaywallChannels = ({
    allowedChannelWallpapers,
    currentChannelWallpaper,
}: Params): (ChannelWallpaperItem | null)[] => {
    if (allowedChannelWallpapers !== undefined) {
        return getChannelWallpapersForPaywall(allowedChannelWallpapers, currentChannelWallpaper);
    }

    return new Array(CHANNEL_COUNT_FOR_WALLPAPER).fill(null);
};
